import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { BadgeComponent } from '../common/badge/badge.component';
import { BadgeColor } from '../common/badge/badge.types';
import { BoxComponent } from '../common/box/box.component';
import { HeadingComponent } from '../common/heading/heading.component';
import { IconColorDirective } from '../common/icon/directives/icon-color.directive';
import { IconComponent } from '../common/icon/icon.component';
import { IconName } from '../icons-container/icons.type';

@Component({
  selector: 'rt-new-item-button',
  templateUrl: 'new-item-button.component.html',
  styleUrls: ['./new-item-button.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    BadgeComponent,
    BoxComponent,
    HeadingComponent,
    IconColorDirective,
    IconComponent,
    NgIf,
  ],
})
export class NewItemButtonComponent {
  @Input() public icon: IconName;
  @Input() public heading: string = '';
  @Input() public subheading: string = '';
  @Input() public badgeText?: string;
  @Input() public badgeVariant: BadgeColor;
}
